import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type GaugeProps = ApiMethodBase & {}

export const updateGauges = ({
    eventEmitter,
}: GaugeProps) => {
    eventEmitter.emit(Event.updateGaugeMetrics);
};

